import React from 'react'
import { Outlet } from 'react-router-dom'

import {
    EnumDispatcherRoutes,
    EnumGlobalRoutes,
    ROUTE_TITLES_CONSTANT,
} from '../app/router/routerConstants'
import CalendarIcon from '../assets/img/ico-calendar.svg?react'
import ChartIcon from '../assets/img/ico-chart.svg?react'
import ChatIcon from '../assets/img/ico-chat.svg?react'
import CustomersIcon from '../assets/img/ico-customers.svg?react'
import GridsIcon from '../assets/img/ico-grids.svg?react'
import NotificationIcon from '../assets/img/ico-notification.svg?react'
import ToolsIcon from '../assets/img/ico-tools.svg?react'
import Header from '../compoments/layout/Header'
import Sidebar from '../compoments/layout/Sidebar'

const DispatcherLayout = () => {
    const pages = [
        {
            icon: <GridsIcon />,
            title: ROUTE_TITLES_CONSTANT[EnumGlobalRoutes.DASHBOARD],
            url: EnumGlobalRoutes.DASHBOARD,
        },
        {
            icon: <CalendarIcon />,
            title: ROUTE_TITLES_CONSTANT[
                EnumDispatcherRoutes.DISPATCHER_SHEDULING
            ],
            url: EnumDispatcherRoutes.DISPATCHER_SHEDULING,
        },
        {
            icon: <ToolsIcon />,
            title: ROUTE_TITLES_CONSTANT[
                EnumDispatcherRoutes.DISPATCHER_TECHNICIANS
            ],
            url: EnumDispatcherRoutes.DISPATCHER_TECHNICIANS,
        },
        {
            icon: <CustomersIcon />,
            title: ROUTE_TITLES_CONSTANT[
                EnumDispatcherRoutes.DISPATCHER_CUSTOMERS_MANAGEMENT
            ],
            url: EnumDispatcherRoutes.DISPATCHER_CUSTOMERS_MANAGEMENT,
        },
        {
            icon: <ChartIcon />,
            title: ROUTE_TITLES_CONSTANT[
                EnumDispatcherRoutes.DISPATCHER_REPORTS
            ],
            url: EnumDispatcherRoutes.DISPATCHER_REPORTS,
        },
        {
            icon: <NotificationIcon />,
            title: ROUTE_TITLES_CONSTANT[EnumGlobalRoutes.NOTIFICATION],
            url: EnumGlobalRoutes.NOTIFICATION,
        },
        {
            icon: <ChatIcon />,
            title: ROUTE_TITLES_CONSTANT[EnumGlobalRoutes.CHAT],
            url: EnumGlobalRoutes.CHAT,
        },
    ]

    return (
        <>
            <Header />
            <Sidebar pages={pages} />
            <div className="wrapper header-fixed sidebar-indentation">
                <Outlet />
            </div>
        </>
    )
}

export default DispatcherLayout
